import React from "react";
import Logout, {FormatDate} from "./utils";
import Storage from "./Storage";
import {Container} from "react-bootstrap";
import Alert from "./Alert";

function DT({children}) {
    return <dt className="col-md-3">{children}</dt>;
}

function DD({children}) {
    return <dd className="col-md-9">{children}</dd>;
}


export default class FEDEXInvoice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoiceGeneralInfo: {},
            chargeSummary: [],
            veloxCharges: [],
            chargesWithoutTrack: [],
            alert: '',
            loading: true,
        };
    }

    render() {
        if (this.state.loading) {
            return (
                <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status"></div>
                </div>
            )
        }
        if (this.state.alert) {
            return <Alert>{this.state.alert}</Alert>
        }
        const summary = this.state.chargeSummary;
        const invoice = this.state.invoiceGeneralInfo;
        const veloxCharges = this.state.veloxCharges;
        const invoiceNumber = this.props.match.params.invoiceNumber;
        let npTotal = 0;
        let veloxTotal = 0;
        let totalVeloxCharges = 0;
        return (
            <div>
                <Container>
                    <h4 className="mt-4">Invoice {invoiceNumber}</h4>
                    <div>
                        <dl className="row">
                            <DT>Net charge</DT>
                            <DD>{Number(invoice.net_charge_cents / 100).toLocaleString()}</DD>
                            <DT>Date</DT>
                            <DD>{FormatDate(invoice.date)}</DD>
                        </dl>
                    </div>

                    {
                        summary.length === 0 ? null :
                            <div>
                                <table className="table table-sm">
                                    <thead>
                                    <tr>
                                        <th>
                                            Category
                                        </th>
                                        <th title="Totals invoice records with tracking numbers, created under NovaPoshta account via Velox API">
                                            NovaPoshta
                                        </th>
                                        <th title="Totals invoice records with tracking numbers, created on ups.com">
                                            Velox
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        summary.map((v, i) => {
                                            npTotal += v.nova_poshta_amount_cents;
                                            veloxTotal += v.velox_amount_cents;
                                            return (
                                                <tr key={i}>
                                                    <th scope="row">{v.charge_category}</th>
                                                    <td>{Number(v.nova_poshta_amount_cents / 100).toLocaleString()}</td>
                                                    <td>{Number(v.velox_amount_cents / 100).toLocaleString()}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                    <tr>
                                        <td><b>TOTAL</b></td>
                                        <td><b>{Number(npTotal / 100).toLocaleString()}</b></td>
                                        <td><b>{Number(veloxTotal / 100).toLocaleString()}</b></td>
                                    </tr>
                                    </tbody>
                                </table>
                                <hr/>
                            </div>
                    }
                </Container>

                {veloxCharges.length === 0 ? null :
                    <div className="container-fluid">
                        <h6 className="mt-2 text-center" style={{'background-color': '#fff10045'}}><b>VELOX CHARGES</b>
                        </h6>
                        <table className="table table-sm">
                            <thead>
                            <tr>
                                <th>Track</th>
                                <th>Reference</th>
                                <th>Shipment Date</th>
                                <th>Service Type</th>
                                <th>Net</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                veloxCharges.map((v, i) => {
                                    const date = new Date(v.transaction_date);
                                    totalVeloxCharges += v.net_amount_cents;
                                    return (
                                        <tr key={i}>
                                            <td>{v.tracking_number}</td>
                                            <td>{v.reference}</td>
                                            <td>{v.shipment_date}</td>
                                            <td>{v.service_type}</td>
                                            <td>{v.net_amount_cents / 100}</td>
                                        </tr>
                                    )
                                })
                            }
                            <tr>
                                <td colSpan="6"><b>TOTAL</b></td>
                                <td><b>{Number(totalVeloxCharges / 100).toLocaleString()}</b></td>
                            </tr>
                            </tbody>
                        </table>
                        <hr/>
                    </div>
                }
            </div>
        )
    }

    componentDidMount() {
        fetch(`/api/v1/admin/fedex-invoices/${this.props.match.params.invoiceNumber}`, {
            method: 'GET',
            headers: {'Authorization': `Bearer ${Storage.getToken()}`},
        })
            .then(response => {
                switch (response.status) {
                    case 200:
                        response.json()
                            .then(data => {
                                this.setState({
                                    invoiceGeneralInfo: data.invoice_general_info,
                                    chargeSummary: data.charge_summary,
                                    veloxCharges: data.velox_charges,
                                })
                            })
                            .catch(err => {
                                this.setState({alert: JSON.stringify(err)});
                            })
                        return
                    case 401:
                        Logout();
                        return
                    default:
                        this.setState({alert: 'Invalid status: ' + response.status});
                        return
                }
            })
            .catch(err => {
                this.setState({alert: JSON.stringify(err)});
            })
            .finally(_ => {
                this.setState({loading: false})
            })
    }
}
